import { normalizeBaseUrl } from "shared-utils";
import { Api as BillingApi } from "../generated/BillingApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const billingApi = new BillingApi({
  baseURL: normalizeBaseUrl(config.billingApiUrl),
});

createAxiosRequestInterceptors(billingApi.instance);

export default billingApi;
